

export type MasterTableDataType = {
  networkId: number;
  networkCode: string;
  networkName: string;
  networkStatus: number;
  clinicId: number;
  insuranceType: number;
  insuranceName: number;
  insuranceGroup: number;
  insurancePlan: {id: number; name: string}[];
  inGroupName: string;
  inPlanName: string;
  insName: string;
  insuranceTypeName: string;
};

export type MasterDataType = {
  networkId: number;
  networkCode: string;
  networkName: string;
  insTypeId: number;
  insNameId: number;
  insGroupId: number | null;
  insPlanId: number[]; // array of numbers
  createdById: number;
  clinicId: number;
  networkStatus: number
};

export type MasterFormDataType = {
  networkCode:string;
  networkName: string;
  insType: { id: number; name: string } | null;
  insurance: { id: number; name: string } | null;
  inGroup: { id: number; name: string } | null;
  inPlan: { id: number; name: string }| null;
  status: number;
};

export type SearchParamsType={
   filter: {
    searchText: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
  clinicId: number;
}

export const initialFormData: MasterFormDataType = {
  insType: null,
  insurance: null,
  inGroup: null,
  inPlan:null,
  networkCode: "",
  networkName: "",
  status: 1,
};
